<template>
  <input ref="dropdownToggle" v-model="searchString"
         autocomplete="off"
         class="form-control dropdown-toggle"
         type="text"
         v-bind="$attrs"
         @keyup="searchLocation($event.target.value)"
         @blur="setFirstSuggestion"
  >
  <ul class="dropdown-menu">
    <li v-for="suggestion in suggestions">
      <a class="dropdown-item" href="#"
         @mousedown="selectLocation(suggestion.loc_id, suggestion.text_val)"
      >{{ suggestion.text_val }}</a>
    </li>
  </ul>
</template>

<script setup>

import {onMounted, ref, watch} from "vue";

const props = defineProps({
  modelValue: Object,
  searchApi: String,
  minLetters: {
    type: Number,
    default: 1
  }
})

const dropdownToggle = ref({});
let dropdownElement;

const emit = defineEmits(['update:modelValue']);

const searchString = ref('');

const suggestions = ref({});

watch(() => props.modelValue, newVal => {
  suggestions.value = {};
  if (!newVal.hasOwnProperty('geo') || !newVal.hasOwnProperty('geoId')) {
    searchString.value = "";
  } else {
    searchString.value = newVal.geo;
  }
}, {immediate: true});

const searchLocation = value => {
  if (value && (value.length >= props.minLetters)) {
    axios.get('/ajax/' + props.searchApi + '?search=' + value).then(response => {
      suggestions.value = response.data;
      dropdownElement.show();
    })
  } else {
    suggestions.value = {};
    dropdownElement.hide();
    emit('update:modelValue', {});
  }
}

const selectLocation = (geoId, geo) => {
  searchString.value = geo;
  emit('update:modelValue', {'geoId': geoId, 'geo': geo});
  suggestions.value = {};
  dropdownElement.hide();
}

const setFirstSuggestion = () => {
  if(suggestions.value[0]) {
    selectLocation(suggestions.value[0].loc_id, suggestions.value[0].text_val);
  }
}

onMounted(() => {
  dropdownElement = new bootstrap.Dropdown(dropdownToggle.value);
});

</script>

<style scoped>

</style>